<template>
  <v-dialog
    :model-value="modelValue"
    min-width="250"
    max-width="290">
    <v-card>
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text v-if="text">
        {{ text }}
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn-secondary
          @click="$emit('cancel')"
        >
          {{ $t("buttons.cancel") }}
        </v-btn-secondary>
        <v-btn-primary
          @click="$emit('confirm')"
        >
          {{ $t("buttons.confirm") }}
        </v-btn-primary>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import {PropType} from "vue";
/*
 * dev note:
 * Don't add translations to this component. default prop values
 * cannot be set from translations. Pass the translations as props.
 */
defineProps({
  modelValue: {
    type: Boolean as PropType<boolean>,
    required: true
  },
  title: {
    type: String as PropType<string>,
    required: true
  },
  text: {
    type: String as PropType<string>,
    required: true
  }
});

defineEmits(["confirm", "cancel"]);
</script>
